import { FC } from "react";
import { ClientManagement } from "~/components/admin/client-management";
import PageMeta from "~/components/common/meta";

type Props = {};

export const ScreenClientList: FC<Props> = () => {
  return (
    <>
      <PageMeta title="Client Management | Art Handler" />
      <ClientManagement />
    </>
  );
};
